// constant variables
export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "9801fa4f-c106-4ff2-974d-413625870384";
export const MOD_CLOSE_SEC = 2.5;
